import React from 'react';

import { createColumnHelper } from '@tanstack/react-table';
import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import { FaEllipsisV } from 'react-icons/fa';

import { WashhubInventory as HubInventoryType } from 'types/washhub';
import { convertUTCToLocal } from 'utils/dateUtils';
import DecomissionedSvg from 'svg/Decommissioned';

const col = createColumnHelper<HubInventoryType>();

/** Verbatim port of WashhubInventory.view.tsx's calculateTotals. */
export const calculateTotals = (data: HubInventoryType) => {
  let totalFullPackages = 0;
  let totalInBoxes = 0;
  let totalInProcess = 0;

  totalFullPackages += (data.fullPackages || []).reduce(
    (sum, pkg) => sum + (pkg.totalItems || 0),
    0,
  );

  totalInBoxes += (data.inBoxes || []).reduce(
    (sum, box) => sum + (box.totalItems || 0),
    0,
  );

  totalInProcess += (data.inProcess || []).reduce(
    (sum, process) => sum + (process.itemCount || 0),
    0,
  );

  return {
    totalFullPackages,
    totalInBoxes,
    totalInProcess,
  };
};

export const buildWashhubInventoryColumns = (
  onDelete: (count: HubInventoryType) => void,
) => [
  col.accessor((count) => count?.washHubDetails?.name, {
    id: 'washHub',
    header: 'Wash Hub',
    minSize: 150,
  }),
  col.accessor((count) => convertUTCToLocal(count?.date, true, true), {
    id: 'date',
    header: 'Date',
    minSize: 110,
  }),
  col.accessor(
    (count) => {
      const totals = calculateTotals(count);
      return (
        totals.totalFullPackages + totals.totalInBoxes + totals.totalInProcess
      );
    },
    {
      id: 'total',
      header: 'Total #',
      minSize: 80,
      size: 100,
      meta: { align: 'center' },
    },
  ),
  col.accessor((count) => count?.notes, {
    id: 'notes',
    header: 'Notes',
    minSize: 200,
    size: 320,
  }),
  col.display({
    id: 'actions',
    header: '',
    minSize: 60,
    size: 60,
    meta: { truncate: false, align: 'center' },
    cell: ({ row: { original: count } }) => (
      <Menu>
        <MenuButton
          as={IconButton}
          icon={<FaEllipsisV />}
          variant="ghost"
          aria-label="Options"
        />
        <MenuList>
          <MenuItem
            icon={<DecomissionedSvg />}
            onClick={(e) => {
              e.stopPropagation();
              onDelete(count);
            }}>
            Delete
          </MenuItem>
        </MenuList>
      </Menu>
    ),
  }),
];
